<template>
  <div>
    <div v-if="reportTypeTest === 'Ziyaret Raporu'">
      <h2 style="text-align: center">Ziyaretler</h2>
      <b-table
          :items="visitReportList.currentVisits"
          :fields="visitReportListHeaders.currentVisitHeaders"
          head-row-variant="info"
          hover
          small
          responsive
          sort-icon-left
          striped
          :per-page="50"
          show-empty
      >
        <template #empty="scope">
          <h6 class="text-center my-5">
            {{ scope.loading ? "Lütfen Bekleyin" : reportErrorMessage ? reportErrorMessage : "Veri Yok"}}
          </h6>
        </template>
        <template #table-busy>
          <div class="text-center">
            <b-spinner
                variant="primary"
                size="lg"
                label="Lütfen Bekleyin..."
            ></b-spinner>
          </div>
        </template>
        <template #cell(visitDate)="data">
          {{ formattedDate(data.item.visitDate,"DD-MM-YYYY") }}
        </template>
        <template #cell(process)="data">
          <slot name="currentActionDetailButton" :model="data.item"></slot>
        </template>
      </b-table>
      <h2 style="text-align: center" class="mt-5 mb-5">Siparişler</h2>
      <b-table
          :items="visitReportList.orders"
          :fields="visitReportListHeaders.ordersHeaders"
          head-row-variant="info"
          hover
          small
          responsive
          sort-icon-left
          striped
          :per-page="50"
          show-empty
      >
        <template #empty="scope">
          <h6 class="text-center my-5">
            {{ scope.loading ? "Lütfen Bekleyin" : reportErrorMessage ? reportErrorMessage : "Veri Yok"}}
          </h6>
        </template>
        <template #table-busy>
          <div class="text-center">
            <b-spinner
                variant="primary"
                size="lg"
                label="Lütfen Bekleyin..."
            ></b-spinner>
          </div>
        </template>
        <template #cell(totalAmount)="data">
          <b>{{ numberConverter(data.item.totalAmount)}}</b>
        </template>
        <template #cell(process)="data">
          <slot name="currentActionDetailButton" :model="data.item"></slot>
        </template>
      </b-table>
      <h2 style="text-align: center" class="mt-5 mb-5">Tahsilatlar</h2>
      <b-table
          :items="visitReportList.payments"
          :fields="visitReportListHeaders.paymentsHeaders"
          head-row-variant="info"
          hover
          small
          responsive
          sort-icon-left
          striped
          :per-page="50"
          show-empty
      >
        <template #cell(credit)="data">
          <b>
            {{ numberConverter(data.item.credit) }}
          </b>
        </template>
        <template #empty="scope">
          <h6 class="text-center my-5">
            {{ scope.loading ? "Lütfen Bekleyin" : reportErrorMessage ? reportErrorMessage : "Veri Yok"}}
          </h6>
        </template>
        <template #table-busy>
          <div class="text-center">
            <b-spinner
                variant="primary"
                size="lg"
                label="Lütfen Bekleyin..."
            ></b-spinner>
          </div>
        </template>
        <template #cell(date)="data">
          {{ formattedDate(data.item.date,"DD-MM-YYYY") }}
        </template>
        <template #cell(process)="data">
          <slot name="currentActionDetailButton" :model="data.item"></slot>
        </template>
      </b-table>
    </div>
    <div v-else>
      <b-table
          :items="reportListData"
          :fields="reportListHeaders"
          head-row-variant="info"
          hover
          small
          responsive
          sort-icon-left
          striped
          :per-page="perPage"
          show-empty
      >
        <template #empty="scope">
          <h6 class="text-center my-5">
            {{ scope.loading ? "Lütfen Bekleyin" : reportErrorMessage ? reportErrorMessage : "Filtreleme Yapın"}}
          </h6>
        </template>
        <template #table-busy>
          <div class="text-center">
            <b-spinner
                variant="primary"
                size="lg"
                label="Lütfen Bekleyin..."
            ></b-spinner>
          </div>
        </template>
        <template #cell(date)="data">
          {{ formattedDate(data.item.date,"DD-MM-YYYY") }}
        </template>
        <template #cell(process)="data">
          <slot name="currentActionDetailButton" :model="data.item"></slot>
        </template>
        <template #cell(quantity)="data">
          <slot name="quantity" :model="data.item"></slot>
        </template>
        <template v-for="item in reportListSlots" #[`cell(${item})`]="data">
          <slot :name="item" :model="data.item"></slot>
        </template>
      </b-table>
    </div>

  </div>
  <!--      </div>-->
  <!--    </div>-->
  <!--  </div>-->
</template>

<script>

import {mapState} from "vuex";
import {formattedDate} from "@/momentHelper";
import {numberConverter} from "../../../../../helpers";

export default {
  components: {
  },
  computed:{
    ...mapState("report",["reportListHeaders","reportListData","reportErrorMessage","visitReportList","reportTypeTest","visitReportListHeaders","reportListSlots"]),

  },
  props:{
    perPage:{
      type:Number,
      default: 10
    }
  },
  data(){
    return {
      reportType: this.reportTypeTest,
    }
  },
  methods:{
    formattedDate,numberConverter
  }
}


</script>